'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = isGenerator;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ### koa isGenerator logic
 *
 * > see: https://github.com/ljharb/is-generator-function/blob/master/index.js
 */
var toStr = Object.prototype.toString;
var fnToStr = Function.prototype.toString;
var isFnRegex = /^\s*(?:function)?\*/;
var hasToStringTag = typeof Symbol === 'function' && (0, _typeof3.default)(Symbol.toStringTag) === 'symbol';
var getProto = Object.getPrototypeOf;
var getGeneratorFunc = function getGeneratorFunc() {
  // eslint-disable-line consistent-return
  if (!hasToStringTag) {
    return false;
  }
  try {
    return Function('return function*() {}')();
  } catch (e) {
    // error
  }
};
var generatorFunc = getGeneratorFunc();
var GeneratorFunction = generatorFunc ? getProto(generatorFunc) : {};

function isGenerator(fn) {
  if (typeof fn !== 'function') {
    return false;
  }

  if (isFnRegex.test(fnToStr.call(fn))) {
    return true;
  }
  if (!hasToStringTag) {
    var str = toStr.call(fn);
    return str === '[object GeneratorFunction]';
  }
  var _proto_ = getProto(fn);

  return _proto_ === GeneratorFunction || (_proto_.displayName || _proto_.name) === 'GeneratorFunctionPrototype';
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/seed/isGenerator.js
// module id = 150
// module chunks = 0